import cnContent from "./token/zh/cn.js";
import usContent from "./token/zh/us.js";
import jpContent from "./token/zh/jp.js";
import koContent from "./token/zh/ko.js";
import geContent from "./token/zh/ge.js";
import ukContent from "./token/zh/uk.js";
import uaeContent from "./token/zh/uae.js";
import frContent from "./token/zh/fr.js";
import sgContent from "./token/zh/sg.js";

import agreementContent from "./agreement/zh-hant.js";

export default {
  "head.index": "首页",
  "head.product": "产品",
  "head.computeProduct": "全球算力值",
  "head.computeProductDesc": "購買算力值，獲取全球算力收益",
  "head.rentalProduct": "服务器租赁",
  "head.rentalProductDesc": "租賃高性能服務器，穩定收益",
  "head.rental": "租赁",
  "head.about": "关于我们",


  // ===== 用户下拉菜单 =====
  "menu.profile": "个人中心",
  "menu.security": "账号安全",
  "menu.settings": "设置",
  "menu.products": "产品列表",
  "menu.deposits": "存币记录",
  "menu.withdraws": "提币记录",
  "menu.walletLog": "交易记录",
  "menu.logout": "退出登录",
  "menu.logoutSuccess": "退出登录成功",

  // ===== 页脚 =====
  "footer.contactEmail": "联系邮箱",

  // ===== 首页 =====
  "home.heroTitle1": "全球新算力领主",
  "home.heroTitle2": "双轮驱动财富引擎",
  "home.heroDesc":
    "平台优先挑选被微软、OpenAI、DeepSeek等大模型巨头提前锁定租赁的成熟站点",
  "home.heroBtn": "立即获取算力收益 →",
  "home.statTrade": "日交易额",
  "home.statTradeValue": "10億+",
  "home.statReliability": "可靠性",
  "home.statGlobal": "服务全球",
  "home.buildTitle1": "建设您的",
  "home.buildTitle2": "专属算力机房",
  "home.buildDesc1": "独立管理 · 独立租赁 · 收益透明 —— 我们只负责运维管理，",
  "home.buildDesc2": "一切收益归于建设者",
  "home.buildFeature1Title": "独立管理",
  "home.buildFeature1Desc": "您拥有机房的完全控制权，自主决定租赁策略与定价",
  "home.buildFeature2Title": "收益透明",
  "home.buildFeature2Desc": "实时财务数据可视化，每一笔收益清晰可查",
  "home.buildFeature3Title": "专业运维",
  "home.buildFeature3Desc": "我们负责硬件维护、网络保障、7×24小时技术支持",
  "home.buildFeature4Title": "收益全归您",
  "home.buildFeature4Desc": "扣除基础运维成本后，所有租赁收益归建设者所有",
  "home.buildBtn": "立即建设 →",
  "home.buildStatsTitle": "📈 建设收益概览",
  "home.buildStatsUpdate": "实时更新",
  "home.buildStatRooms": "已建成机房",
  "home.buildStatServers": "运行中服务器",
  "home.buildStatProfit": "建设者总收益",
  "home.buildStatPayback": "平均回本周期",
  "home.buildStatMonth": "个月",
  "home.buildCta": "🎯 立即加入，开启您的算力基建事业",
  "home.buildCtaBtn": "了解详情",
  "home.featuresBadge": "✦ 核心优势",
  "home.featuresTitle1": "为什么选择",
  "home.featuresTitle2": "AETRIVOL",
  "home.feature1Title": "高效便捷",
  "home.feature1Desc": "AETRIVOL利用自身优势，让个人有机会享受到算力时代红利",
  "home.feature2Title": "国家级安全",
  "home.feature2Desc": "多层网络防护，数据加密传输，7×24小时安全监控",
  "home.feature3Title": "高性能硬件",
  "home.feature3Desc": "NVIDIA最新一代GPU，配合高速NVMe存储和DDR5内存",
  "home.feature4Title": "全球节点",
  "home.feature4Desc": "覆盖亚太、欧洲、北美数据中心，低延迟全球加速",
  "home.appBadge": "📱 移动端",
  "home.appTitle": "敬请期待",
  "home.appDesc1": "AETRIVOL 移动端 App 敬请期待，",
  "home.appDesc2": "让您随时随地掌握算力市场动态，",
  "home.appDesc3": "一键管理您的 GPU 算力。",
  "home.appQrText": "扫码下载 App",
  "home.appStore": "App Store",
  "home.googlePlay": "Google Play",
  "home.walletsTitle1": "合作",
  "home.walletsTitle2": "伙伴",
  "home.walletsDesc": "连接您信任的钱包，安全管理资产",
  "home.settleTitle1": "实时",
  "home.settleTitle2": "结算动态",
  "home.settleDesc": "全球用户实时收益结算展示",
  "home.modalTitle": "敬请期待",
  "home.modalDesc1": "目前暂无新机房建设项目",
  "home.modalDesc2": "感谢您的关注与支持！",
  "home.modalBtn": "我知道了",

  // ===== 首页-算力国家 =====
  "tokenList.title1": "选择您的",
  "tokenList.title2": "算力国家",
  "tokenList.desc": "全球领先算力国家，低投入、高回报",
  "tokenList.buy": "立即购买",
  "tokenList.more": "更多产品",
  "tokenList.tagHot": "🔥 热门",
  "tokenList.tagProfit": "💰 高收益",
  "tokenList.tagRecommend": "⭐ 推荐",
  "tokenList.tagNew": "🆕 新品",

  // ===== 首页-服务器租赁 =====
  "serverList.title1": "服务器",
  "serverList.title2": "租赁",
  "serverList.desc": "成熟高性能服务器，助您产生超额的租赁收益",
  "serverList.dailyIncome": "日收益",
  "serverList.value": "服务器价值",
  "serverList.yield": "收益率",
  "serverList.gpu": "GPU",
  "serverList.vram": "显存",
  "serverList.storage": "存储",
  "serverList.status": "状态",
  "serverList.available": "可租赁",
  "serverList.full": "已满额",
  "serverList.countdown": "距开始",
  "serverList.over": "距结束",
  "serverList.yunxz": "运行中",
  "serverList.yunxzjs": "距结束",
  "serverList.days": "天",
  "serverList.btnFull": "已满额",
  "serverList.btnRent": "立即租赁",
  "serverList.btnWait": "未開始",
  "serverList.look": "查看详情",
  "serverList.btnEnded": "已結束",
  "serverList.more": "查看更多产品",
  "serverList.spec1": "入门版",
  "serverList.spec2": "轻量版",
  "serverList.spec3": "性能版",
  "serverList.spec4": "旗舰版",
  "serverList.tagHot": "🔥 热门",
  "serverList.tagRecommend": "⭐ 推荐",
  "serverList.tagNew": "🌟 新上市",

  // ===== 首页-结算轮播 =====
  "settle.amount": "结算金额",
  "settle.status": "已结算",
  "settle.power": "算力值",
  "settle.rental": "服务器租赁",
  "settle.basic": "基本收益",
  "settle.cycle": "周期收益",
  "settle.phase1": "一阶段",
  "settle.phase2": "二阶段",
  "settle.phase3": "三阶段",
  "settle.phase4": "四阶段",

  // ===== 会员中心 =====
  "member.recharge": "充值",
  "member.withdraw": "提现",
  "member.tabProducts": "我的产品",
  "member.tabHistory": "历史记录",
  "member.tabWalletLog": "钱包记录",
  "member.tabDeposits": "存币记录",
  "member.tabWithdraws": "提现记录",
  "member.tabAddresses": "提现地址",
  "member.avatarAlt": "用户头像",
  "member.settingsTitle": "设置",
  "member.logoutTitle": "退出登录",
  "member.tabTokenProduct": "算力产品",
  "member.tabRentProduct": "租赁产品",

  // ===== 设置页 =====
  "setting.back": "返回",
  "setting.title": "⚙️ 设置",
  "setting.menuProfile": "个人信息",
  "setting.menuSecurity": "账号安全",
  "setting.menuVerify": "账号认证",
  "setting.menuChangePwd": "修改密码",
  "setting.menuTradePwd": "交易密码",
  "setting.getUserInfoFail": "获取用户信息失败",

  // ===== 设置页-个人信息 =====
  "profile.title": "个人信息",
  "profile.subtitle": "管理您的基本资料",
  "profile.avatar": "头像",
  "profile.avatarAlt": "头像",
  "profile.changeAvatar": "更换头像",
  "profile.systemAvatar": "系统头像",
  "profile.firstName": "名",
  "profile.firstNamePlaceholder": "请输入名",
  "profile.lastName": "姓",
  "profile.lastNamePlaceholder": "请输入姓",
  "profile.phone": "电话",
  "profile.phonePlaceholder": "请输入电话",
  "profile.address": "地址",
  "profile.addressPlaceholder": "请输入地址",
  "profile.saving": "保存中...",
  "profile.saveInfo": "保存信息",
  "profile.selectSystemAvatar": "选择系统头像",
  "profile.avatarAltNum": "头像{count}",
  "profile.selectImageFile": "请选择图片文件",
  "profile.imageTooLarge": "图片大小不能超过 5MB",
  "profile.uploadFail": "上传失败",
  "profile.updateFail": "更新失败",
  "profile.updateSuccess": "更新成功",
  "profile.uploadFailNoPath": "上传失败，未获取到图片地址",
  "profile.uploadFailRetry": "上传失败，请稍后重试",
  "profile.saveFail": "保存失败",
  "profile.saveSuccess": "保存成功",
  "profile.saveFailRetry": "保存失败，请稍后重试",

  // ===== 设置页-账号认证 =====
  "verifyPanel.title": "账号认证",
  "verifyPanel.subtitle": "提升账户权限与信任等级",
  "verifyPanel.realName": "实名认证",
  "verifyPanel.realNameDesc": "您已经提交了实名认证信息",
  "verifyPanel.verified": "已认证 ✓",
  "verifyPanel.goVerify": "去认证 →",

  // ===== 设置页-账号安全 =====
  "securityPanel.title": "账号安全",
  "securityPanel.subtitle": "保障您的账号安全",
  "securityPanel.phoneBind": "手机绑定",
  "securityPanel.phoneBound": "已绑定 {phone}",
  "securityPanel.notBound": "未绑定",
  "securityPanel.emailBind": "邮箱绑定",
  "securityPanel.emailBound": "已绑定 {email}",
  "securityPanel.twofa": "两步验证 (2FA)",
  "securityPanel.twofaOn": "已开启 · 每次登录需输入动态验证码",
  "securityPanel.twofaOff": "未开启 · 建议开启以增强账户安全",
  "securityPanel.twofaEnabled": "已开启 ✓",
  "securityPanel.enableTwofa": "开启两步验证",
  "securityPanel.disableTwofaTitle": "关闭两步验证",
  "securityPanel.enableTwofaTitle": "开启两步验证",
  "securityPanel.qrAlt": "两步验证二维码",
  "securityPanel.tip1": "1. 下载 Google Authenticator 或 Microsoft Authenticator",
  "securityPanel.tip2": "2. 扫描上方二维码 或 输入密钥",
  "securityPanel.copy": "复制",
  "securityPanel.verifyCode": "验证码",
  "securityPanel.verifyCodePlaceholder": "请输入6位动态验证码",
  "securityPanel.emailCode": "邮箱验证码",
  "securityPanel.emailCodePlaceholder": "请输入邮箱验证码",
  "securityPanel.resend": "{count}s 后重试",
  "securityPanel.sendCode": "发送验证码",
  "securityPanel.disableWarning1": "关闭两步验证后，您的账户将失去额外安全保护。",
  "securityPanel.disableWarning2": "请确认您要关闭两步验证。",
  "securityPanel.cancel": "取消",
  "securityPanel.confirmDisable": "确认关闭",
  "securityPanel.confirmEnable": "确认开启",
  "securityPanel.getSecretFail": "获取密钥失败",
  "securityPanel.copySuccess": "密钥已复制到剪贴板",
  "securityPanel.copyFail": "复制密钥失败",
  "securityPanel.enterVerifyCode": "请输入6位动态验证码",
  "securityPanel.operationFail": "操作失败",
  "securityPanel.twofaEnabledMsg": "两步验证已开启！",
  "securityPanel.twofaDisabledMsg": "两步验证已关闭！",
  "securityPanel.enterEmailCode": "请输入邮箱验证码",

  // ===== 设置页-修改密码 =====
  "changePwd.title": "修改密码",
  "changePwd.subtitle": "定期更换密码，保障账号安全",
  "changePwd.warning": "您还未开启两步验证，无法修改密码。请先开启两步验证。",
  "changePwd.goEnable": "去开启",
  "changePwd.newPwd": "新密码",
  "changePwd.newPwdPlaceholder": "请输入新密码（至少6位）",
  "changePwd.confirmPwd": "确认新密码",
  "changePwd.confirmPwdPlaceholder": "请再次输入新密码",
  "changePwd.emailCode": "邮箱验证码",
  "changePwd.emailCodePlaceholder": "请输入邮箱验证码",
  "changePwd.resend": "{count}s 后重试",
  "changePwd.sendCode": "发送验证码",
  "changePwd.confirmBtn": "确认修改",
  "changePwd.twofaDesc": "请输入您的两步验证码以发送邮箱验证码",
  "changePwd.pwdTooShort": "新密码至少6位",
  "changePwd.pwdMismatch": "两次输入的新密码不一致",
  "changePwd.enableTwofaFirst": "请先开启两步验证后再修改密码",
  "changePwd.codeError": "验证码错误",
  "changePwd.enterEmailCode": "请输入邮箱验证码",
  "changePwd.success": "密码修改成功！请重新登录",

  // ===== 设置页-交易密码 =====
  "tradePwd.title": "交易密码",
  "tradePwd.subtitle": "保护您的资产安全",
  "tradePwd.warning": "您还未开启两步验证，无法修改交易密码。请先开启两步验证。",
  "tradePwd.goEnable": "去开启",
  "tradePwd.newPwd": "新交易密码",
  "tradePwd.newPwdPlaceholder": "请输入新交易密码（至少6位）",
  "tradePwd.confirmPwd": "确认交易密码",
  "tradePwd.confirmPwdPlaceholder": "请再次输入新交易密码",
  "tradePwd.emailCode": "邮箱验证码",
  "tradePwd.emailCodePlaceholder": "请输入邮箱验证码",
  "tradePwd.resend": "{count}s 后重试",
  "tradePwd.sendCode": "发送验证码",
  "tradePwd.confirmBtn": "确认修改",
  "tradePwd.twofaDesc": "请输入您的两步验证码以发送邮箱验证码",
  "tradePwd.pwdTooShort": "新交易密码至少6位",
  "tradePwd.pwdMismatch": "两次输入的交易密码不一致",
  "tradePwd.enableTwofaFirst": "请先开启两步验证后再修改交易密码",
  "tradePwd.codeError": "验证码错误",
  "tradePwd.enterEmailCode": "请输入邮箱验证码",
  "tradePwd.success": "交易密码修改成功！",

  // ===== 会员中心-历史记录 =====
  "history.tabToken": "算力记录",
  "history.tabRent": "租赁记录",

  // ===== 会员中心-算力历史记录 =====
  "historyToken.type": "类型",
  "historyToken.allType": "全部类型",
  "historyToken.buy": "购买",
  "historyToken.income": "收益",
  "historyToken.reset": "重置",
  "historyToken.loading": "加载中...",
  "historyToken.empty": "暂无产品",
  "historyToken.date": "日期",
  "historyToken.product": "产品",
  "historyToken.quantity": "数量",
  "historyToken.amount": "金额",
  "historyToken.fee": "手续费",
  "historyToken.total": "总额",
  "historyToken.time": "时间",
  "historyToken.profit": "盈亏",
  "historyToken.deduct": "抵扣",
  "historyToken.profitPositive": "盈利",
  "historyToken.profitNegative": "亏损",
  "historyToken.unknownStatus": "未知状态",
  "historyToken.paginationInfo": "共 {total} 条，第 {page} / {totalPages} 页",
  "historyToken.firstPage": "首页",
  "historyToken.prevPage": "上一页",
  "historyToken.nextPage": "下一页",
  "historyToken.lastPage": "末页",
  "historyToken.perPage": "{count}条/页",

  // ===== 会员中心-租赁历史记录 =====
  "historyServer.type": "类型",
  "historyServer.allType": "全部类型",
  "historyServer.buy": "购买",
  "historyServer.income": "收益",
  "historyServer.reset": "重置",
  "historyServer.loading": "加载中...",
  "historyServer.empty": "暂无产品",
  "historyServer.date": "日期",
  "historyServer.product": "产品",
  "historyServer.share": "份额",
  "historyServer.amount": "金额",
  "historyServer.fee": "手续费",
  "historyServer.total": "总额",
  "historyServer.time": "时间",
  "historyServer.unknownStatus": "未知状态",
  "historyServer.paginationInfo": "共 {total} 条，第 {page} / {totalPages} 页",
  "historyServer.firstPage": "首页",
  "historyServer.prevPage": "上一页",
  "historyServer.nextPage": "下一页",
  "historyServer.lastPage": "末页",
  "historyServer.perPage": "{count}条/页",

  // ===== 会员中心-存币记录 =====
  "deposit.loading": "加载中...",
  "deposit.empty": "暂无存币记录",
  "deposit.coin": "币种",
  "deposit.quantity": "数量",
  "deposit.network": "网络",
  "deposit.address": "地址",
  "deposit.status": "状态",
  "deposit.time": "时间",
  "deposit.success": "成功",
  "deposit.processing": "处理中",
  "deposit.paginationInfo": "共 {total} 条，第 {page} / {totalPages} 页",
  "deposit.firstPage": "首页",
  "deposit.prevPage": "上一页",
  "deposit.nextPage": "下一页",
  "deposit.lastPage": "末页",
  "deposit.perPage": "{count}条/页",

  // ===== 会员中心-提现记录 =====
  "withdrawal.loading": "加载中...",
  "withdrawal.empty": "暂无提现记录",
  "withdrawal.coin": "币种",
  "withdrawal.quantity": "数量",
  "withdrawal.network": "网络",
  "withdrawal.address": "地址",
  "withdrawal.status": "状态",
  "withdrawal.time": "时间",
  "withdrawal.statusProcessing": "处理中",
  "withdrawal.statusSuccess": "成功",
  "withdrawal.statusFailed": "失败",
  "withdrawal.statusUnknown": "未知",
  "withdrawal.paginationInfo": "共 {total} 条，第 {page} / {totalPages} 页",
  "withdrawal.firstPage": "首页",
  "withdrawal.prevPage": "上一页",
  "withdrawal.nextPage": "下一页",
  "withdrawal.lastPage": "末页",
  "withdrawal.perPage": "{count}条/页",

  // ===== 会员中心-提现地址 =====
  "addresse.title": "提现地址",
  "addresse.addAddress": "+ 添加地址",
  "addresse.loading": "加载中...",
  "addresse.empty": "暂无提现地址",
  "addresse.coin": "币种",
  "addresse.network": "网络",
  "addresse.address": "地址",
  "addresse.time": "时间",
  "addresse.action": "操作",
  "addresse.delete": "删除",
  "addresse.deleteSuccess": "删除成功",
  "addresse.paginationInfo": "共 {total} 条，第 {page} / {totalPages} 页",
  "addresse.firstPage": "首页",
  "addresse.prevPage": "上一页",
  "addresse.nextPage": "下一页",
  "addresse.lastPage": "末页",
  "addresse.perPage": "{count}条/页",

  // ===== 会员中心-钱包记录 =====
  "walletLog.type": "类型",
  "walletLog.allType": "全部类型",
  "walletLog.reset": "重置",
  "walletLog.loading": "加载中...",
  "walletLog.empty": "暂无产品",
  "walletLog.project": "项目",
  "walletLog.amount": "金额",
  "walletLog.time": "时间",
  "walletLog.day": "天",
  "walletLog.paginationInfo": "共 {total} 条，第 {page} / {totalPages} 页",
  "walletLog.firstPage": "首页",
  "walletLog.prevPage": "上一页",
  "walletLog.nextPage": "下一页",
  "walletLog.lastPage": "末页",
  "walletLog.perPage": "{count}条/页",
  "walletLog.typeDeposit": "存币",
  "walletLog.typeWithdraw": "提现",
  "walletLog.typePay": "支付",
  "walletLog.typeTokenIncome": "算力盈利",
  "walletLog.typeTokenLoss": "算力亏损",
  "walletLog.typeServerIncome": "服务器收益",
  "walletLog.typeTransferReturn": "提现退回",
  "walletLog.typeFreezeBuy": "(购买)冻结",
  "walletLog.typeServerRent": "服务器租金",
  "walletLog.typeUnfreeze": "(到期)解冻",
  "walletLog.typeCompute": "算力",
  "walletLog.typeRent": "租赁",
  "walletLog.statusUnknown": "未知状态",
  "walletLog.titlePower": "算力",
  "walletLog.titleRent": "租赁",
  "walletLog.statusDeposit": "存币",
  "walletLog.statusWithdrawal": "提现",
  "walletLog.statusPay": "支付",
  "walletLog.statusPowerProfit": "算力盈利",
  "walletLog.statusPowerLoss": "算力亏损",
  "walletLog.statusServerIncome": "服务器收益",
  "walletLog.statusWithdrawalReturn": "提现退回",
  "walletLog.statusPurchaseFreeze": "(购买)冻结",
  "walletLog.statusServerRent": "服务器租金",
  "walletLog.statusExpireUnfreeze": "(到期)解冻",

  // ===== 会员中心-资产总览 =====
  "memberBox.assetOverview": "资产总览",
  "memberBox.realTime": "实时更新",
  "memberBox.totalAssets": "总资产",
  "memberBox.vsYesterday": "较昨日",
  "memberBox.availableBalance": "可用余额",
  "memberBox.frozenFunds": "占用资金",
  "memberBox.incomeTrend": "收益趋势",
  "memberBox.hashIncome": "算力收益",
  "memberBox.leaseIncome": "租赁收益",
  "memberBox.hashIncomeTotal": "算力收益总额",
  "memberBox.leaseIncomeTotal": "租赁收益总额",
  "memberBox.totalIncome": "总收益",
  "memberBox.vsLastDay": "较上日",
  "memberBox.time7d": "7天",
  "memberBox.time15d": "15天",
  "memberBox.time30d": "30天",

  // ===== 会员中心-产品列表 =====
  "productToken.region": "地区",
  "productToken.allRegion": "全部地区",
  "productToken.status": "状态",
  "productToken.allStatus": "全部状态",
  "productToken.statusActive": "进行中",
  "productToken.statusCompleted": "已完成",
  "productToken.statusFrozen": "已冻结",
  "productToken.statusUnknown": "未知状态",
  "productToken.reset": "重置",
  "productToken.loading": "加载中...",
  "productToken.empty": "暂无产品",
  "productToken.quantity": "数量",
  "productToken.period": "周期",
  "productToken.latestProfit": "最新盈亏",
  "productToken.settledProfit": "已结算盈亏",
  "productToken.periodProfit": "周期盈亏",
  "productToken.totalProfit": "盈亏总额",
  "productToken.action": "操作",
  "productToken.view": "查看",
  "productToken.day": "天",
  "productToken.paginationInfo": "共 {total} 条，第 {page} / {totalPages} 页",
  "productToken.firstPage": "首页",
  "productToken.prevPage": "上一页",
  "productToken.nextPage": "下一页",
  "productToken.lastPage": "末页",
  "productToken.perPage": "{count}条/页",
  "productToken.detailTitle": "产品详情",
  "productToken.productCode": "产品编号",
  "productToken.orderCode":"订单编号",
  "productToken.orderName":"产品名称",
  "productToken.tradeInfo": "交易信息",
  "productToken.tradeTime": "交易时间",
  "productToken.buyPrice": "购买价格",
  "productToken.principal": "本金",
  "productToken.fee": "手续费",
  "productToken.latestPrice": "最新价格",
  "productToken.profitInfo": "盈亏信息",
  "productToken.estimatedProfit": "预估总盈亏",
  "productToken.remark": "备注",
  "productToken.close": "关闭",

  // ===== 会员中心-服务器产品列表 =====
  "productServer.region": "地区",
  "productServer.allRegion": "全部地区",
  "productServer.status": "状态",
  "productServer.allStatus": "全部状态",
  "productServer.statusActive": "进行中",
  "productServer.statusCompleted": "已完成",
  "productServer.statusFrozen": "已冻结",
  "productServer.statusUnknown": "未知状态",
  "productServer.reset": "重置",
  "productServer.loading": "加载中...",
  "productServer.empty": "暂无产品",
  "productServer.productName": "产品名称",
  "productServer.share": "份额",
  "productServer.countdown": "倒计时",
  "productServer.unsettledIncome": "未结收益",
  "productServer.settled": "已结算",
  "productServer.totalIncome": "收益总额",
  "productServer.action": "操作",
  "productServer.view": "查看",
  "productServer.day": "天",
  "productServer.paginationInfo": "共 {total} 条，第 {page} / {totalPages} 页",
  "productServer.firstPage": "首页",
  "productServer.prevPage": "上一页",
  "productServer.nextPage": "下一页",
  "productServer.lastPage": "末页",
  "productServer.perPage": "{count}条/页",
  "productServer.detailTitle": "产品详情",
  "productServer.productCode": "产品编号",
  "productServer.orderCode":"订单编号",
  "productServer.orderName":"产品名称",
  "productServer.leaseInfo": "租赁信息",
  "productServer.leaseDate": "租赁日期",
  "productServer.rent": "租金",
  "productServer.maintenanceFee": "维护费",
  "productServer.profitInfo": "收益信息",
  "productServer.estimatedLeaseIncome": "预估总租赁收益",
  "productServer.settledIncome": "已结算收益",
  "productServer.phase": "{count}阶段",
  "productServer.currentPhase": "当前阶段",
  "productServer.remark": "备注",
  "productServer.close": "关闭",

  // ===== 注册/资格申请页 =====
  "register.back": "返回登录",
  "register.statusBadge": "资格申请 · 人工审核",
  "register.title": "申请权利资格",
  "register.subtitle": "提交资料后，我们将在24小时内完成审核并通过邮件通知您",
  "register.basicInfo": "基本信息",
  "register.firstNamePlaceholder": "请输入您的名",
  "register.lastNamePlaceholder": "请输入您的姓",
  "register.genderMale": "男",
  "register.genderFemale": "女",
  "register.genderSecret": "保密",
  "register.birthdayPlaceholder": "请选择出生日期",
  "register.maritalStatus": "婚姻状况",
  "register.maritalUnmarried": "未婚",
  "register.maritalMarried": "已婚",
  "register.maritalDivorced": "离异",
  "register.maritalWidowed": "丧偶",
  "register.contactAddress": "联系地址",
  "register.addressPlaceholder": "请输入联系地址",
  "register.occupationInfo": "职业信息",
  "register.workUnitPlaceholder": "请输入工作单位",
  "register.workAddressPlaceholder": "请输入您的工作地址",
  "register.occupationPlaceholder": "请输入您的职业",
  "register.incomePlaceholder": "请选择年收入范围",
  "register.incomeBelow5": "5万以下",
  "register.income5to10": "5万 - 10万",
  "register.income10to20": "10万 - 20万",
  "register.income20to50": "20万 - 50万",
  "register.income50to100": "50万 - 100万",
  "register.incomeAbove100": "100万以上",
  "register.otherInfo": "其他信息",
  "register.remarksPlaceholder": "其他补充说明（选填，如申请理由、特殊需求等）",
  "register.accountInfo": "账户信息",
  "register.inviteCodePlaceholder": "请输入核验编码",
  "register.emailPlaceholder": "请输入邮箱地址（审核结果将发送至此邮箱）",
  "register.verifyCodePlaceholder": "请输入邮箱验证码",
  "register.agreementText": "本人承诺以上填写信息真实有效，并同意",
  "register.agreementLink": "《用户协议》",
  "register.auditNotice1": "提交后我们将进行人工审核",
  "register.auditNotice2": "24小时内",
  "register.auditNotice3": " 通过邮件通知您，请确保邮箱地址准确无误。",
  "register.submitBtn": "提交审核申请",
  "register.submitting": "提交中...",
  "register.hasAccount": "已有账号？",
  "register.gotoLogin": "去登录",
  "register.successTitle": "提交成功！",
  "register.successDesc1": "您的资格申请已收到，我们将在",
  "register.successDesc2": "24小时内",
  "register.successDesc3": " 完成审核。",
  "register.successDesc4": "审核结果将通过邮件发送至：",
  "register.successTip": "请留意查收邮件，感谢您的申请！",
  "register.modalBtn": "我知道了",
  "register.sending": "发送中",
  "register.resendSuffix": "后重试",
  "register.auditNoticeMid": "，审核结果将在",
  "register.invalidEmail": "请输入有效的邮箱地址",
  "register.codeSent": "验证码已发送到您的邮箱，请查收",
  "register.inviteCodeInvalid": "请输入6位邀请码",
  "register.verifyCodeInvalid": "请输入4位邮箱验证码",
  "register.firstNameRequired": "请输入您的真实姓名",
  "register.lastNameRequired": "请输入您的真实姓名",
  "register.genderRequired": "请选择您的性别",
  "register.birthdayRequired": "请选择您的出生日期",
  "register.maritalRequired": "请选择您的婚姻状态",
  "register.addressRequired": "请输入您的地址",
  "register.workUnitRequired": "请输入您的工作单位",
  "register.workAddressRequired": "请输入您的工作地址",
  "register.occupationRequired": "请输入您的职业",
  "register.incomeRequired": "请选择您的年收入范围",
  "register.agreeRequired": "请先阅读并同意资格审核条款与隐私政策",
  "register.registerFail": "注册失败",
  "register.submitFail": "提交失败，请稍后重试",

  // ===== 登录页 =====
  "login.title": "AI算力云",
  "login.subtitle": "AI computing power cloud",
  "login.usernamePlaceholder": "请输入账号名称",
  "login.passwordPlaceholder": "请输入账号密码",
  "login.forgotPassword": "忘记密码",
  "login.loginBtn": "登录",
  "login.noQualification": "还没有资格？",
  "login.applyNow": "立即申请资格",
  "login.loginSuccess": "登录成功",
  "login.enterCredentials": "请输入账号和密码",
  "login.loading": "加载中...",

  // ===== 重置密码页 =====
  "reset.back": "返回登录",
  "reset.title": "找回密码",
  "reset.subtitleStep1": "验证身份，重置您的账号密码",
  "reset.subtitleStep2": "设置新密码，确保账号安全",
  "reset.emailPlaceholder": "请输入注册邮箱地址",
  "reset.captchaPlaceholder": "请输入验证码",
  "reset.sending": "发送中",
  "reset.getCaptcha": "获取验证码",
  "reset.nextStep": "下一步",
  "reset.newPasswordPlaceholder": "请设置新密码（至少6位）",
  "reset.confirmPasswordPlaceholder": "请再次输入新密码",
  "reset.resetBtn": "立即重置",
  "reset.rememberPassword": "还记得密码？",
  "reset.gotoLogin": "去登录",
  "reset.invalidEmail": "请输入有效的邮箱地址",
  "reset.captchaSent": "验证码发送成功",
  "reset.captchaInvalid": "请输入有效的验证码（至少4位）",
  "reset.passwordTooShort": "新密码至少需要6位",
  "reset.passwordMismatch": "两次输入的密码不一致",
  "reset.resetSuccess": "密码重置成功！请重新登录",

  // ===== 身份认证页 =====
  "verify.statusBadge": "身份认证 · 信息填写",
  "verify.title": "账户认证",
  "verify.subtitle": "请填写您的真实身份信息，提交后将进行人工审核",
  "verify.accountSecurity": "账户安全",
  "verify.loginPassword": "登录密码",
  "verify.confirmLoginPassword": "确认登录密码",
  "verify.tradePassword": "交易密码",
  "verify.confirmTradePassword": "确认交易密码",
  "verify.securityQuestion": "安全问题",
  "verify.securityAnswer": "问题答案",
  "verify.basicInfo": "基本信息",
  "verify.country": "所属国家",
  "verify.countryPlaceholder": "请选择所属国家",
  "verify.phone": "手机号码",
  "verify.realName": "真实姓名",
  "verify.idNumber": "身份证号码",
  "verify.idPhoto": "身份证照片",
  "verify.frontPhoto": "正面照",
  "verify.backPhoto": "背面照",
  "verify.handPhoto": "手持身份证照片",
  "verify.uploading": "上传中...",
  "verify.clickUpload": "点击上传",
  "verify.uploadHint": "支持 JPG / PNG，建议 5MB 以内",
  "verify.uploadHandHint": "请手持身份证拍摄，确保面部和身份证信息清晰可见",
  "verify.reupload": "重新上传",
  "verify.auditNotice1": "提交后将进行人工审核",
  "verify.auditNoticeMid": "，审核结果将在",
  "verify.auditNotice2": "24小时内",
  "verify.auditNotice3": " 通知您，请确保信息真实准确。",
  "verify.submitBtn": "提交认证",
  "verify.submitting": "提交中...",
  "verify.hasAccount": "已有账号？",
  "verify.gotoLogin": "去登录",
  "verify.successTitle": "提交成功！",
  "verify.successDesc1": "您的认证信息已提交，我们将在",
  "verify.successDesc2": "24小时内",
  "verify.successDesc3": " 完成审核。",
  "verify.successDesc4": "审核结果将通过短信通知您。",
  "verify.successTip": "请保持手机畅通，感谢您的配合！",
  "verify.modalBtn": "我知道了",
  "verify.loginPasswordPlaceholder": "请设置登录密码（至少6位）",
  "verify.confirmLoginPasswordPlaceholder": "请再次输入登录密码",
  "verify.tradePasswordPlaceholder": "请设置交易密码（至少6位）",
  "verify.confirmTradePasswordPlaceholder": "请再次输入交易密码",
  "verify.securityQuestionPlaceholder": "请输入安全问题",
  "verify.securityAnswerPlaceholder": "请输入问题答案",
  "verify.phonePlaceholder": "请输入手机号码",
  "verify.realNamePlaceholder": "请输入真实姓名（与身份证一致）",
  "verify.idNumberPlaceholder": "请输入身份证号码",
  "verify.uploadImage": "请上传图片文件",
  "verify.imageTooLarge": "图片大小不能超过 5MB",
  "verify.uploadSuccess": "图片上传成功",
  "verify.uploadFail": "图片上传失败",
  "verify.uploadFailRetry": "图片上传失败，请稍后重试",
  "verify.passwordTooShort": "密码至少为6位",
  "verify.confirmPasswordRequired": "请再次输入密码",
  "verify.passwordMismatch": "两次输入的密码不一致",
  "verify.tradePasswordTooShort": "交易密码至少为6位",
  "verify.confirmTradePasswordRequired": "请再次输入交易密码",
  "verify.tradePasswordMismatch": "两次输入的交易密码不一致",
  "verify.securityQuestionRequired": "请输入安全问题",
  "verify.countryRequired": "请选择所属国家",
  "verify.phoneInvalid": "请输入有效的手机号码",
  "verify.realNameRequired": "请输入真实姓名（至少2位）",
  "verify.idNumberInvalid": "请输入有效的身份证号码",
  "verify.idFrontRequired": "请上传身份证正面照",
  "verify.idBackRequired": "请上传身份证背面照",
  "verify.idHandRequired": "请上传手持身份证照片",
  "verify.submitSuccess": "提交成功",
  "verify.submitFail": "提交失败",
  "verify.submitFailRetry": "提交失败，请稍后重试",

  // ===== 租赁列表页 =====
  "rental.title1": "服务器",
  "rental.title2": "租赁",
  "rental.desc": "精选高性能服务器，投资您的个人算力资产，助力全球算力发展",
  "rental.statServers": "可租赁服务器",
  "rental.statAvailability": "可用性",
  "rental.statSupport": "客服支持",
  "rental.searchPlaceholder": "搜索服务器名称、GPU型号...",
  "rental.filterAll": "全部",
  "rental.filterHot": "🔥 热门",
  "rental.filterRecommend": "⭐ 推荐",
  "rental.filterNew": "🌟 新上市",
  "rental.sortDefault": "默认排序",
  "rental.sortRemainingAsc": "剩余 ↑",

  "rental.sortRemainingDesc": "剩余 ↓",
  "rental.sortValueAsc": "总价值 ↑",
  "rental.sortValueDesc": "总价值 ↓",
  "rental.sortIncomeAsc": "日收益 ↑",
  "rental.sortIncomeDesc": "日收益 ↓",

  "rental.sortStartAsc": "活动开始 ↑",
  "rental.sortStartDesc": "活动开始 ↓",
  "rental.sortEndAsc": "活动结束 ↑",
  "rental.sortEndDesc": "活动结束 ↓",
  "rental.resultCount": "共 {count} 台服务器",
  "rental.loading": "加载中...",
  "rental.empty": "没有找到匹配的服务器",
  "rental.totalValue": "总价值",
  "rental.country": "国家",
  "rental.incomeTrend": "收益趋势",
  "rental.activityPeriod": "📅 周期",
  "rental.remaining": "⏳ 剩余",
  "rental.days": "天",
  "rental.memory": "内存",
  "rental.storage": "存储",
  "rental.bandwidth": "带宽",
  "rental.status": "状态",
  "rental.available": "✅ 可租赁",
  "rental.full": "⏳ 已满",
  "rental.countdown": "距开始",
  "rental.btnFull": "已满额",
  "rental.btnRent": "立即租赁",
  "rental.btnWait": "未開始",
  "rental.btnEnded": "已結束",
  "rental.btnRentList": "租赁",
  "rental.btnNotStart": "未開始",
  "rental.NotRent": "不可租赁",
  "rental.value": "价值",
  "rental.prev": "← 上一页",
  "rental.next": "下一页 →",
  "rental.perPage": "{count} 条/页",
  "rental.processBadge": "📋 租赁流程",
  "rental.processTitle1": "三步轻松",
  "rental.processTitle2": "租用服务器",
  "rental.step1Icon": "🔍",
  "rental.step1Title": "选择服务器",
  "rental.step1Desc": "浏览服务器列表，根据您的需求选择合适的配置",
  "rental.step2Icon": "📝",
  "rental.step2Title": "提交租赁申请",
  "rental.step2Desc": "填写租赁时长、用途等信息，提交审核",
  "rental.step3Icon": "🚀",
  "rental.step3Title": "部署使用",
  "rental.step3Desc": "审核通过后立即部署，开始您的AI算力之旅",
  "rental.ctaTitle": "还没有找到合适的服务器？",
  "rental.ctaDesc": "联系我们获取定制化方案，专业团队为您推荐最优配置",
  "rental.ctaContact": "联系客服",
  "rental.ctaFaq": "查看常见问题",
  "rental.spec1": "入门版",
  "rental.spec2": "轻量版",
  "rental.spec3": "性能版",
  "rental.spec4": "旗舰版",
  "rental.tagHot": "🔥 热门",
  "rental.tagRecommend": "⭐ 推荐",
  "rental.tagNew": "🌟 新上市",
  "rental.statusActive": "进行中",
  "rental.statusPending": "未开始",
  "rental.statusEnded": "已结束",
  "rental.income": "收益",
  "rental.progress": "进度",
  "rental.countryAlt": "国家",
  "rental.monday": "周一",
  "rental.tuesday": "周二",
  "rental.wednesday": "周三",
  "rental.thursday": "周四",
  "rental.friday": "周五",
  "rental.saturday": "周六",
  "rental.sunday": "周日",

  // ===== 提现页 =====
  "withdraw.title": "💸 账户提现",
  "withdraw.desc": "快速提现，安全到账",
  "withdraw.balance": "可用余额",
  "withdraw.methodCrypto": "🪙 加密货币",
  "withdraw.methodBank": "🏦 银行提现",
  "withdraw.selectCoin": "选择币种",
  "withdraw.selectNetwork": "选择提现网络",
  "withdraw.address": "提现地址",
  "withdraw.bindAddress": "➕ 绑定地址",
  "withdraw.selectAddress": "请选择提现地址",
  "withdraw.noAddress": "暂无可用地址",
  "withdraw.noAddressTip": "⚠️ 暂无绑定的 {coin} 地址，请先",
  "withdraw.bindLink": "绑定地址",
  "withdraw.amount": "提现金额",
  "withdraw.emailCode": "邮箱验证码",
  "withdraw.emailCodePlaceholder": "请输入邮箱验证码",
  "withdraw.resend": "{count}s 后重试",
  "withdraw.sendCode": "发送验证码",
  "withdraw.expectedArrival": "预计到账",
  "withdraw.networkFee": "网络手续费",
  "withdraw.actualArrival": "实际到账",
  "withdraw.submitting": "⏳ 提交中...",
  "withdraw.confirm": "🚀 确认提现",
  "withdraw.selectFirst": "👆 请选择币种和网络",
  "withdraw.minAmount": "最小提现金额",
  "withdraw.maxAmount": "最大提现金额",
  "withdraw.all": "全部",
  "withdraw.available": "可用",
  "withdraw.insufficientBalance": "余额不足",
  "withdraw.enterAmount": "请输入提现金额",
  "withdraw.enterCode": "请输入邮箱验证码",
  "withdraw.selectAddressFirst": "请选择提现地址",
  "withdraw.success": "提现申请已提交",
  "withdraw.fail": "提现失败",
  "withdraw.arrivalTime": "10-30 分钟",
  "withdraw.noticeTitle": "📋 提现注意事项",
  "withdraw.notice1Title": "到账时间",
  "withdraw.notice1Desc":
    "加密货币提现通常需要 10-30 分钟到账，具体取决于区块链网络确认速度。",
  "withdraw.notice2Title": "最低提现金额",
  "withdraw.notice2Desc":
    "单笔提现最低金额为 0.001 BTC 或等值其他币种，低于此金额将无法提交。",
  "withdraw.notice3Title": "地址核对",
  "withdraw.notice3Desc":
    "请仔细核对提现地址，错误操作可能导致资产永久丢失，平台不承担相应责任。",
  "withdraw.notice4Title": "手续费说明",
  "withdraw.notice4Desc":
    "提现手续费由区块链网络决定，平台不额外收取费用。手续费将从提现金额中扣除。",
  "withdraw.codeError": "验证码错误",
  "withdraw.twoFactorDesc": "请输入您的两步验证码以发送邮箱验证码",
  "withdraw.selectBank": "选择银行账户",
  "withdraw.selectBankPlaceholder": "请选择银行账户",
  "withdraw.bankBOC": "中国银行",
  "withdraw.bankICBC": "工商银行",
  "withdraw.addBank": "+ 添加新账户",
  "withdraw.bankAmount": "提现金额 (USD)",
  "withdraw.exchangeRate": "💱 汇率",
  "withdraw.arrivalTimeLabel": "⏱️ 到账时间",
  "withdraw.bankArrivalTime": "1-3 个工作日",
  "withdraw.bankConfirm": "🏦 确认提现",
  "withdraw.bankSuccess": "🏦 银行提现申请已提交，1-3 个工作日内到账",

  // ===== 充值页 =====
  "depositPage.title": "💰 账户充值",
  "depositPage.desc": "選擇充值方式，快速到賬",
  "depositPage.balance": "當前餘額",
  "depositPage.methodCrypto": "🪙 加密貨幣",
  "depositPage.methodOnline": "💳 線上充值",
  "depositPage.coin": "幣種",
  "depositPage.protocol": "協議",
  "depositPage.qrAlt": "充值二維碼",
  "depositPage.qrPlaceholder": "暫無二維碼",
  "depositPage.copy": "📋 複製",
  "depositPage.copied": "✅",
  "depositPage.addressWarning": "⚠️ 僅支持 <strong>{coin}</strong> ({protocol}) 轉賬，請勿轉入其他資產",
  "depositPage.amountPlaceholder": "輸入充值金額（可選）",
  "depositPage.transferBtn": "🚀 我已轉賬",
  "depositPage.emptyState": "👆 請選擇幣種和協議",
  "depositPage.noticeTitle": "📋 充值注意事項",
  "depositPage.onlineCardName1": "信用卡/借記卡",
  "depositPage.onlineCardDesc1": "Visa · Mastercard",
  "depositPage.onlineCardBtn1": "支付 →",
  "depositPage.onlineCardName2": "銀行轉賬",
  "depositPage.onlineCardDesc2": "1-3 工作日到賬",
  "depositPage.onlineCardBtn2": "獲取信息 →",
  "depositPage.onlineCardName3": "第三方支付",
  "depositPage.onlineCardDesc3": "支付寶 · 微信 · Paypal",
  "depositPage.onlineCardBtn3": "支付 →",
  "depositPage.notice1Title": "到賬時間",
  "depositPage.notice1Desc": "加密貨幣充值需要等待區塊鏈網絡確認，通常需要 10-30 分鐘，具體取決於網絡擁堵情況。",
  "depositPage.notice2Title": "最低充值金額",
  "depositPage.notice2Desc": "單筆充值最低金額為 0.001 BTC 或等值其他幣種，低於此金額將無法入賬。",
  "depositPage.notice3Title": "確認數要求",
  "depositPage.notice3Desc": "BTC 需要 3 次網絡確認，ETH/TRX/USDT 需要 12 次確認後才會記入賬戶餘額。",
  "depositPage.notice4Title": "資產安全提醒",
  "depositPage.notice4Desc": "請仔細核對充值地址和協議類型，錯誤操作可能導致資產永久丟失，平台不承擔相應責任。",
  "depositPage.feeInfo": "💸 手續費：{fee}",

  // ===== 绑定钱包地址页 =====
  "bindAddress.title": "🔗 綁定錢包地址",
  "bindAddress.desc": "綁定您的加密貨幣錢包地址，用於提現",
  "bindAddress.cardTitle": "➕ 綁定新錢包",
  "bindAddress.selectCoin": "選擇幣種",
  "bindAddress.selectProtocol": "選擇協議",
  "bindAddress.walletAddress": "錢包地址",
  "bindAddress.walletAddressPlaceholder": "請輸入您的錢包地址",
  "bindAddress.emailCode": "郵箱驗證碼",
  "bindAddress.emailCodePlaceholder": "請輸入郵箱驗證碼",
  "bindAddress.resend": "{count}s 後重試",
  "bindAddress.sendCode": "發送驗證碼",
  "bindAddress.confirmBind": "🔗 確認綁定",
  "bindAddress.noticeTitle": "📋 綁定須知",
  "bindAddress.twoFactorDesc": "請輸入您的兩步驗證碼以發送郵箱驗證碼",
  "bindAddress.notice1Title": "資產安全",
  "bindAddress.notice1Desc": "請確保您綁定的錢包地址歸您本人所有，且私鑰由您自行保管。",
  "bindAddress.notice2Title": "提現限制",
  "bindAddress.notice2Desc": "綁定後 24 小時內不可提現，以保障賬戶資產安全。",
  "bindAddress.notice3Title": "郵箱驗證",
  "bindAddress.notice3Desc": "每次綁定新錢包都需要通過郵箱驗證碼確認操作。",
  "bindAddress.notice4Title": "地址核對",
  "bindAddress.notice4Desc": "請仔細核對錢包地址，錯誤綁定可能導致資產無法找回。",
  "bindAddress.msgAddressInvalid": "⚠️ 請先填寫正確的錢包地址",
  "bindAddress.msgCodeError": "驗證碼錯誤",
  "bindAddress.msgFormInvalid": "請完整填寫所有信息並獲取郵箱驗證碼",

  // ===== 错误页 =====
  "error.backHome": "返回首頁",
  "error.refresh": "刷新重試",
  "error.footerTip": "如果問題持續存在，請聯繫技術支持",
  "error.title404": "頁面未找到",
  "error.desc404": "您訪問的頁面不存在或已被移除",

  phase: "階段",




  country: {
    1: "美国",
    2: "中国",
    3: "日本",
    4: "韩国",
    5: "德国",
    6: "英国",
    7: "法国",
    8: "阿联酋",
    9: "新加坡",
    10: "以色列",
  },

  token: {
    us: {
      content: {
        title: "",
        content: usContent.content,
      },
      t1: {
        title: "发展现状",
        content: usContent.t1,
      },
      t2: {
        title: "核心优势",
        content: usContent.t2,
      },
      t3: {
        title: "面临挑战",
        content: usContent.t3,
      },
      t4: {
        title: "未来趋势",
        content: usContent.t4,
      },
    },
    cn: {
      content: {
        title: "",
        content: cnContent.content,
      },
      t1: {
        title: "发展现状",
        content: cnContent.t1,
      },
      t2: {
        title: "核心优势",
        content: cnContent.t2,
      },
      t3: {
        title: "面临挑战",
        content: cnContent.t3,
      },
      t4: {
        title: "未来趋势",
        content: cnContent.t4,
      },
    },
    jp: {
      content: {
        title: "",
        content: jpContent.content,
      },
      t1: {
        title: "发展现状",
        content: jpContent.t1,
      },
      t2: {
        title: "核心优势",
        content: jpContent.t2,
      },
      t3: {
        title: "面临挑战",
        content: jpContent.t3,
      },
      t4: {
        title: "未来趋势",
        content: jpContent.t4,
      },
    },
    ko: {
      content: {
        title: "",
        content: koContent.content,
      },
      t1: {
        title: "发展现状",
        content: koContent.t1,
      },
      t2: {
        title: "核心优势",
        content: koContent.t2,
      },
      t3: {
        title: "面临挑战",
        content: koContent.t3,
      },
      t4: {
        title: "未来趋势",
        content: koContent.t4,
      },
    },
    ge: {
      content: {
        title: "",
        content: geContent.content,
      },
      t1: {
        title: "发展现状",
        content: geContent.t1,
      },
      t2: {
        title: "核心优势",
        content: geContent.t2,
      },
      t3: {
        title: "面临挑战",
        content: geContent.t3,
      },
      t4: {
        title: "未来趋势",
        content: geContent.t4,
      },
    },
    uk: {
      content: {
        title: "",
        content: ukContent.content,
      },
      t1: {
        title: "发展现状",
        content: ukContent.t1,
      },
      t2: {
        title: "核心优势",
        content: ukContent.t2,
      },
      t3: {
        title: "面临挑战",
        content: ukContent.t3,
      },
      t4: {
        title: "未来趋势",
        content: ukContent.t4,
      },
    },
    fr: {
      content: {
        title: "",
        content: frContent.content,
      },
      t1: {
        title: "发展现状",
        content: frContent.t1,
      },
      t2: {
        title: "核心优势",
        content: frContent.t2,
      },
      t3: {
        title: "面临挑战",
        content: frContent.t3,
      },
      t4: {
        title: "未来趋势",
        content: frContent.t4,
      },
    },
    uae: {
      content: {
        title: "",
        content: uaeContent.content,
      },
      t1: {
        title: "发展现状",
        content: uaeContent.t1,
      },
      t2: {
        title: "核心优势",
        content: uaeContent.t2,
      },
      t3: {
        title: "面临挑战",
        content: uaeContent.t3,
      },
      t4: {
        title: "未来趋势",
        content: uaeContent.t4,
      },
    },
    sg: {
      content: {
        title: "",
        content: sgContent.content,
      },
      t1: {
        title: "发展现状",
        content: sgContent.t1,
      },
      t2: {
        title: "核心优势",
        content: sgContent.t2,
      },
      t3: {
        title: "面临挑战",
        content: sgContent.t3,
      },
      t4: {
        title: "未来趋势",
        content: sgContent.t4,
      },
    },
  },

  // ===== 首页-补充（alt 属性等） =====
  "home.altQr": "扫码下载",
  "home.altApp": "App 截图",
  "home.altWallet": "钱包图标",

  // ===== 租赁详情页 =====
  "detail.breadcrumbHome": "首页",
  "detail.breadcrumbRental": "服务器租赁",
  "detail.breadcrumbDetail": "详情",
  "detail.badgeHot": "🔥 热门推荐",
  "detail.badgeAvailable": "✅ 可租赁",
  "detail.badgeSold": "⏳ 已租满",
  "detail.badgeEnded": "⏳ 已结束",
  "detail.badgePending": "⏳ 未开始",
  "detail.code": "编码: ",
  "detail.specTitle": "完整规格参数",
  "detail.specGpu": "GPU 型号",
  "detail.specVram": "显存容量",
  "detail.specStorage": "存储容量",
  "detail.specRam": "内存",
  "detail.specBandwidth": "带宽",
  "detail.specValue": "服务器价值",
  "detail.specCountry": "国家",
  "detail.specCountryFlag": "国家国旗",
  "detail.specStatus": "状态",
  "detail.statusFull": "⏳ 已满",
  "detail.statusEnded": "⏳ 已结束",
  "detail.statusPending": "⏳ 未开始",
  "detail.statusAvailable": "✅ 可租赁",
  "detail.chartTitle": "收益趋势",
  "detail.chartRealTime": "实时",
  "detail.chartHint": "点击查看大图",
  "detail.chart7d": "7天",
  "detail.chart15d": "15天",
  "detail.chart30d": "30天",
  "detail.statMax": "最高",
  "detail.statAvg": "平均",
  "detail.statMin": "最低",
  "detail.statChange": "收益率",
  "detail.descTitle": "产品描述",
  "detail.regionTitle": "地区说明",
  "detail.panelTitle": "💎 立即租赁",
  "detail.statusDotFull": "● 已满",
  "detail.statusDotEnded": "● 已结束",
  "detail.statusDotPending": "● 未开始",
  "detail.statusDotAvailable": "● 可租赁",
  "detail.activityPeriod": "📅 周期时间",
  "detail.daysLeft": "余",
  "detail.days": "天",
  "detail.subscribeShare": "🎚️ 认购份额",
  "detail.customShare": "自定义份额",
  "detail.incomeDetail": "📈 预估收益明细",
  "detail.incomeTip": "预估收益仅为参考数值，实际收益请以结算数据为准",
  "detail.estimate": "预估",
  "detail.rate": "收益率:",
  "detail.settleDate": "结算日:",
  "detail.moreStages": "还有 {count} 个阶段",
  "detail.hoverExpand": "悬停展开",
  "detail.totalIncome": "预估收益总额",
  "detail.fundDetail": "💰 资金明细",
  "detail.rentalAmount": "租赁金额",
  "detail.maintenanceFee": "维护费",
  "detail.feeFormula": "总价值*{percent}%*{fee}%",
  "detail.tierDiscount": "阶梯优惠",
  "detail.subscribeTip": "(认购{percent}%)",
  "detail.discountDetail": "🎯 优惠阶梯明细",
  "detail.subscribeGte": "认购 ≥ {percent}%",
  "detail.currentSubscribe": "当前认购 {percent}%，优惠 -${discount}",
  "detail.total": "总计",
  "detail.btnFull": "已满",
  "detail.btnEnded": "已结束",
  "detail.btnPending": "未开始",
  "detail.btnRent": "立即租赁",
  "detail.btnOutOfStock": "暂时缺货",
  "detail.guaranteeSupport": "7×24 客服支援",
  "detail.guaranteeData": "數據安全保障",
  "detail.guaranteeSla": "99.9% SLA",
  "detail.recommendBadge": "🔄 你可能還喜歡",
  "detail.recommendTitle1": "推荐",
  "detail.recommendTitle2": "服务器",
  "detail.recValue": "价值",
  "detail.recDetail": "查看详情 →",
  "detail.faqBadge": "❓ 常见问题",
  "detail.faqTitle1": "租赁",
  "detail.faqTitle2": "FAQ",
  "detail.chartModalTitle": "📈 收益趋势图",
  "detail.spec0": "入门版",
  "detail.spec1": "轻量版",
  "detail.spec2": "性能版",
  "detail.spec3": "旗舰版",
  "detail.spec4": "超旗舰",
  "detail.faq1Q": "租赁服务器需要押金吗？",
  "detail.faq1A": "对于首次租赁的用户，我们可能收取一定比例的押金。长期合作客户可享受押金减免政策。具体金额以结算页面为准。",
  "detail.faq2Q": "租赁到期后如何续租？",
  "detail.faq2A": "您可以在控制台中的「我的租赁」页面进行续租操作。支持按天、按周、按月、按季续租，续租价格与当前租赁价格一致。",
  "detail.faq3Q": "服务器出现故障怎么办？",
  "detail.faq3A": "我们提供 7×24 小时技术支持服务。如遇硬件故障，我们将在 2 小时内响应并在 24 小时内完成维修或更换。",
  "detail.faq4Q": "可以提前终止租赁吗？",
  "detail.faq4A": "可以。提前终止租赁需支付剩余租期 30% 的违约金。具体条款请在租赁时仔细阅读《租赁服务协议》。",
  "detail.faq5Q": "租赁服务器的数据安全如何保障？",
  "detail.faq5A": "我们采用企业级数据加密技术，所有数据在传输和存储过程中均进行加密保护。租赁结束后，您的数据将被完全清除。",
  "detail.unitWan": "万",
  "detail.msgOutOfStock": "该服务器暂时缺货",
  "detail.msgSelectShare": "请选择认购份额",
  "detail.msgRentFail": "租赁失败",
  "detail.msgRentSuccess": "租赁成功",
  "detail.msgContact": "请联系客服：400-888-8888",
  "detail.pwdTitle": "租赁确认",
  "detail.pwdLabel": "请输入交易密码",
  "detail.pwdPlaceholder": "请输入交易密码",
  "detail.pwdConfirm": "确认租赁",
  "detail.pwdCancel": "取消",
  "detail.rentNow": "💎 立即租赁",
  "detail.rentAmount": "租賃金額",
  "detail.subscribe": "認購",
  "detail.descProduct": "產品描述",
  "detail.descRegion": "地區說明",
  "detail.rentNowBtn": "🚀 立即租賃",
  "detail.outOfStock": "⏳ 暫時缺貨",
  "detail.rentyunxz": "运行中",
  "detail.stages": "個階段",
  "detail.discount": "優惠",
  "detail.rentConfirm": "租賃確認",
  "detail.enterPassword": "請輸入交易密碼",
  "detail.confirmRent": "確認租賃",
  "detail.cancel": "取消",
  "detail.outOfStockMsg": "該服務器暫時缺貨",
  "detail.selectShareMsg": "請選擇認購份額",
  "detail.rentFail": "租賃失敗",
  "detail.rentSuccess": "租賃成功",
  "detail.contactService": "請聯繫客服：400-888-8888",
  "detail.tenThousand": "萬",

  // ===== 算力信息页 =====
  "info.emptyTitle": "目前没有算力服务器",
  "info.emptyDesc": "敬请期待，我们正在努力为您准备更多优质算力资源",
  "info.collapse": "收起",
  "info.expand": "展开",
  "info.collapseDetail": "收起详情",
  "info.expandDetail": "展开详情",
  "info.priceTrend": "📈 价格趋势",
  "info.unit": "单位",
  "info.latestPrice": "最新价格",
  "info.lastPrice": "昨日价格",
  "info.increase": "增幅",
  "info.buyNow": "立即购买",
  "info.buyCompute": "购买算力",
  "info.selectPeriod": "选择周期",
  "info.day": "天",
  "info.periodTime": "周期时间",
  "info.purchaseQuantity": "购买数量",
  "info.expectedProfit": "预估收益",
  "info.profitTip": "预估收益仅为历史均值，实际收益请以结算数据为准",
  "info.baseProfit": "基础收益",
  "info.settle24h": "24小时结算",
  "info.periodProfit": "周期收益",
  "info.settleDue": "到期结算",
  "info.totalProfit": "总收益",
  "info.fundDetail": "资金明细",
  "info.purchaseAmount": "购买金额",
  "info.buyFormula": "最新价x购买数量",
  "info.fee": "手续费",
  "info.feeFormula": "购买金额*{fee}%",
  "info.total": "总计",
  "info.cancel": "取消",
  "info.confirmBuy": "确认购买",
  "info.tradeConfirm": "交易确认",
  "info.enterPassword": "请输入交易密码",
  "info.confirmPay": "确认支付",
  "info.chart7d": "7天",
  "info.chart15d": "15天",
  "info.chart30d": "30天",
  "info.price": "价格",
  "info.maxValue": "最大值",
  "info.noData": "暂无数据",
  "info.fetchFail": "获取数据失败",
  "info.selectProduct": "请先选择产品",
  "info.quantityMin": "购买数量不能小于1",
  "info.priceError": "当前价格异常，请稍后再试",
  "info.buySuccess": "购买成功！",
  "info.tradeFail": "交易失败，请稍后再试",
  "info.passwordError": "交易密码错误，请重新输入",
  "info.buyFail": "购买失败，请稍后再试",

  // ===== 关于我们页 =====
  "about.tocTitle": "📑 目录",
  "about.toc1": "执掌数字黄金",
  "about.toc2": "核心产品矩阵",
  "about.toc3": "Aetrivol安全可靠",
  "about.toc4": "投资价值",
  "about.section1Title": "执掌数字黄金：成为智能时代的“超级新算力领主”",
  "about.section1P1":
    "当全球大模型跨入万亿参数决战、具身智能全面爆发的今天，算力已经彻底取代石油，成为支配世界财富的终极硬通货。科技巨头们不惜代价疯狂扫货GPU，动辄数亿的智算中心造价将普通投资者拒之门外。Aetrivol顺应时代应运而生。我们通过创新的算力值锚定机制与算力服务器租赁模型，打破资产垄断，让您用最简单、最灵活的方式，直享这场全人类历史上最大的财富复利盛宴。",
  "about.section2Title": "核心产品矩阵：双轮驱动的财富引擎",
  "about.section2H1": "创新产品一：【算力值（Compute Value / CV）】——全球算力资产的“通证化红利”",
  "about.section2P1":
    "· 打破门槛，微型资产化：我们把全球实体智算中心、高端GPU服务器（英伟达Blackwell、华为昇腾等）的整体算力进行标准化拆分。1点【算力值】，就代表您拥有全球智算网络中特定份额的算力所有权。",
  "about.section2P2":
    "· 像买基金一样买GPU：最低仅需小额资金认购【算力值】，即可打破“一卡难求”的壁垒。您持有的算力值在平台中24小时不间断运行，每日躺迎该算力在全球AI大模型、智能体（Agent）调用中所产生的数字化现金流分红。",
  "about.section2P3":
    "· 高流动性，随时变现：算力值具备极强的资产流动性。随着全球算力需求的暴增，算力值本身具备极高的溢价空间，您可随时在平台内进行交易变现。",
  "about.section2H2": "核心业务二：【算力服务器租赁（Server Leasing）】——稳健长协的“数字包租公”模型",
  "about.section2P4":
    "· 实体资产认购，专属服务器所有权：投资者可直接认购平台旗下的整台或标准机柜的算力服务器。每一台服务器均在链上真实映射、拥有唯一实体机身SN码。",
  "about.section2P5":
    "· 长协托管租赁，坐收稳定高租金：认购后，服务器直接托管于平台在全球绿色算力枢纽（如中国西部东数西算节点、北欧、中东等）的顶级智算中心内。平台替您将服务器精准租赁给急需算力的大模型研发商、高校科研所或垂直领域AI企业，为您锁定3至5年的长协稳定高回报租金。",
  "about.section3Title": "为什么Aetrivol能够化风险为绝对确定性？",
  "about.section3P1":
    "· 100% 物理资产链上锚定：我们拒绝空中楼阁。无论是您持有的算力值，还是您租赁的服务器，均在链上实时映射到正在并网、高频轰鸣的实体加速卡硬件上，资产看得见、摸得着、可核验。",
  "about.section3P2":
    "· 顶尖能效与“抗地缘”双保险：我们包装的标的数据中心100%配备“微型核能（SMR）/光伏直供电”或处于绝对安全的非冲突法律管辖区，彻底规避全球局部电网海啸和地缘政治波动的风险。",
  "about.section3P3":
    "· 巨头信用背书与长协保障：平台优先挑选被微软、OpenAI、DeepSeek等大模型巨头提前锁定租赁的成熟站点，用科技巨头的信用为您做收益背书。",
  "about.section4Title": "过去他们投资土地、投资石油；今天，我们投资算力。",
  "about.section4P1":
    "当全人类的智慧和业务都在向数字世界迁移，算力就是这个新世界唯一的建筑材料。加入 Aetrivol，购买您的算力值，开启您的算力服务器租赁之旅。把您的资本转化为重塑世界的算力原子，共享这场智能激增的财富狂飙！",

  agreement: agreementContent,
};


